import React, { useState, useCallback, useMemo } from 'react'
import { css } from '@emotion/react'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input/input'
import { getCountries } from 'react-phone-number-input'
// import * as FlagIcons from 'country-flag-icons/string/3x2'
import Flags from 'country-flag-icons/react/3x2'
import enCountryLabels from 'react-phone-number-input/locale/en.json'
import { Dropdown } from 'util/ui'

const flagStyle = css`
  width: 24px;
  height: 16px;
  top: 3px;
`

const COUNTRY_OPTIONS = ['_US', '_GB', '_AU', ...getCountries()].map(key => {
  const country = key.startsWith('_') ? key.slice(1) : key
  const text = enCountryLabels[country]
  const FlagComponent = Flags[country]
  return {
    key,
    text,
    value: country,
    content: (
      <>
        <FlagComponent title={text} css={flagStyle} /> {text}
      </>
    ),
  }
})

const CountrySelect = React.memo(({ value, onChange }) => {
  const handleChange = useCallback(
    (_, { value: newValue }) => {
      onChange(newValue)
    },
    [onChange]
  )

  const FlagComponent = useMemo(
    () => {
      return Flags[value]
    },
    [value]
  )

  return (
    <Dropdown
      onChange={handleChange}
      scrolling
      options={COUNTRY_OPTIONS}
      value={value}
      trigger={
        <FlagComponent title={enCountryLabels[value]} css={flagStyle} />
        // <img
        //   src={`https://flag.pk/flags/4x3/${value}.svg`}
        //   alt={enCountryLabels[value]}
        // />
      }
      css={css`
        &&& {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 12px;
          display: inline-flex;
          align-items: center;
          line-height: 1.2;
          margin-right: 8px;
          .dropdown.icon {
            margin-left: 8px;
          }
          .item > img {
            vertical-align: middle !important;
          }
        }
      `}
    />
  )
})

const PhoneNumber = React.forwardRef(({ error, ...rest }, forwardedRef) => {
  const [country, setCountry] = useState(rest.defaultCountry || 'US')
  const handleCountryChange = useCallback(
    c => {
      setCountry(c)
    },
    [setCountry]
  )

  return (
    <div
      css={css`
        position: relative;
      `}
    >
      <CountrySelect
        labels={enCountryLabels}
        value={country}
        onChange={handleCountryChange}
      />
      <PhoneInput
        {...rest}
        ref={forwardedRef}
        defaultCountry="US"
        country={country}
        placeholder="Optional"
        css={css`
          padding-left: 68px !important;
        `}
      />
    </div>
  )
})

export default PhoneNumber
